import React from "react";
import SvgIcon from "../../assets/icons/SvgIcon";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { logout } from "../../redux/slices/authSlice";
import Tooltip from "../Tooltip";
import { DOMAIN_URL } from "../../clientConfig";
import Button from "../Button";
import "./index.scss";
import CustomerNotification from "../Notification/CustomerNotification";

interface NewAdminNavbarProps {
  openSidebar: () => void;
}

const AdminNavbar: React.FC<NewAdminNavbarProps> = ({ openSidebar }) => {
  const dispatch: AppDispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
  };

  const handleViewWebsite = () => {
    window.open(DOMAIN_URL, "_blank");
  };

  return (
    <header className="admin-navbar z-[999] py-3.5 px-6 sticky top-0 bg-white border-b border-shadow-Light-Color/10">
      <nav className="w-full flex justify-between items-center md:px-6">
        <div>
          <button type="button" className="md:hidden" onClick={openSidebar}>
            <SvgIcon iconName="meneIcon" className="size-8" />
          </button>
        </div>
        <div className="flex gap-x-8 items-center cursor-pointer">
          <Button
            variant="secondary"
            className="!bg-transparent !text-steel-blue hover:!text-white view-website px-3 py-2 h-10 mr-2"
            onClick={handleViewWebsite}
          >
            <SvgIcon iconName="web" className="lg:mr-2" />
            <span className="hidden lg:block">View Website</span>
          </Button>
          <Tooltip message="Notification">
            <CustomerNotification />
          </Tooltip>
          <Tooltip message="Logout">
            <button type="button" onClick={handleLogout}>
              <SvgIcon iconName="logout" className="size-8" />
            </button>
          </Tooltip>
        </div>
      </nav>
    </header>
  );
};

export default AdminNavbar;
